
































































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import PaddingVideoInfo from "@/api/paddingVideoInfo";

@Component({
    components: {
        'modal': Modal,
        'edit-icon': EditIcon,
    },
})
export default class FieldPaddingVideoInfo extends CommonVue {
    @Model('update') public padding_video_info_list!: PaddingVideoInfo[];
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public padding_video_info: PaddingVideoInfo = null;
    public isNewElement: boolean = false;
    public showModal: boolean = false;

    // noinspection JSMethodCanBeStatic
    public edit(element: PaddingVideoInfo) {
        this.padding_video_info = element;
        this.isNewElement = false;
        this.showModal = true;
    }

    public newPaddingVideoInfo() {
        this.padding_video_info = new PaddingVideoInfo();
        this.isNewElement = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.padding_video_info) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.isNewElement) {
                this.padding_video_info_list.push(this.padding_video_info);
            }
            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save lesson video info', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.padding_video_info.start_time || !this.padding_video_info.end_time) {
            throw Error('Please insert the start and end time.');
        }
    }

    public deleteClicked() {
        const newList = this.padding_video_info_list.filter((value) => {
            return value !== this.padding_video_info;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }

}

